/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

/**
 * This file contains Launch Darkly configurations which are SDK key name, feature key, targeted user
 * information.
 *
 * For more information please visit: https://docs.launchdarkly.com/v1.0/docs/js-sdk-reference
 */

/**
 * SDK key name which is used for retriving the launch darkly client id from config.json,
 * which gets generated while starting up the app from environment variables.
 * Keep this field in config.json as empty string, because while starting of the server, it will get replaced
 * with proper launch darkly environment specific "Client ID", which is being passed as environment variable
 * to the server
 */
export const Admin_Portal_LaunchDarklyEnvKeyName = "ADMIN_PORTAL_LAUNCHDARKLY_CLIENT_ID";
export const FC_Portal_LaunchDarklyEnvKeyName = "FC_PORTAL_LAUNCHDARKLY_CLIENT_ID";
/**
 * User details for adding a user to launch darkly system, which can be viewed in "Users" section
 * of launch darkly dashboard. This particular user will get added to launch darkly environment, of which
 * client id is consumed.
 * Please note that user keys, including e-mail addresses, are case sensitive.
 */
export const launchDarklyUser = {
  key: "",
  custom: {
  }
};
/**
 * Feature toggle key that is retrived from launch darkly environment to enable/disable a particular feature
 */
export const launchDarklyFeatureToggleKey = {
    ADMIN_PORTAL: {
      DIY_GW_REG_FEATURE_KEY: "diy-gateway-registration",
      DIY_FORGE_APP: "forge-diy-app-enabled",
      VIRTUAL_GATEWAY_ENABLED: "virtual-gateway-enabled",
      SIMPLY_CONNECT_ENABLED: "simply-connect-enabled",
      FORGE_EPM_ENABLED: "forge-epm-enabled",
      GATEWAY_AZURE_PROVISIONING: "fc-gateway-azure-provisioning",
      GATEWAY_AZURE_PROVISIONING_SITE: "fc-gateway-azure-provisioning-site"
    },
    FC_PORTAL: {
       EPM_DIY_GW_REG_FEATURE_KEY: "epm-diy-registration-enabled",
    }
};
